import {Component, OnInit, EventEmitter, Output, ViewChild, OnChanges, SimpleChanges, Input} from '@angular/core';
import { Router } from '@angular/router';
import { SharedService } from '../../services/SharedService.service';
import {Message} from 'primeng/components/common/api';
import {MessageService} from 'primeng/components/common/messageservice';
import {GrowlModule} from 'primeng/growl';
import {TranslateService} from '@ngx-translate/core';
import {ConfirmationService} from "primeng/api";
import { AppPdfComponent } from '../../components/app-pdf';
import {AppArcComponent} from "../../components/app-arc/app-arc.component";
import {NgbModal, NgbModalOptions} from '@ng-bootstrap/ng-bootstrap';
import {Favorites} from "../../model/favorites";
import {ListLayoutComponent} from "../../components/list-layout";
import {DomSanitizer, SafeStyle} from "@angular/platform-browser";
import {json} from 'ng4-validators/src/app/json/validator';
import {Observable} from 'rxjs/Rx';

@Component({
  selector: 'app-dashboard',
  templateUrl: './tab-layout.component.html',
  styleUrls: ['./tab-layout.component.css'],
  providers: [SharedService, MessageService]
})
export class TabLayoutComponent implements OnChanges {
  routeLinks: any[];
  routeButtons: any[];
  routeBtmButtons: any[];
  activeLinkIndex = -1;
  title = '';
  msgs: Message[] = [];
  showMenu = true;
  askfav=true;
  marginzero: SafeStyle;
  public userRoles: any[]=[];
  public icon:string="star-o";
  public color:string ="#415A63" ;
  public hcolor:string = "";
  @Input() refShow;
  @Input() filedis;
  transStatus:any[] = [
      {'val':0,'title':'NEW','class':'status-text label btn-sm col-xs-4 margin-btm','style':{'background': 'white', 'color': 'black', 'border': '1px solid gray'}},
      {'val':1,'title':'UNDER Process','class':'status-text label btn-sm col-xs-4 margin-btm','style':{'background': '#afaf26', 'color': 'white', 'border': '1px solid gray',}},
      {'val':2,'title':'DONE','class':'status-text label btn-sm col-xs-4 margin-btm','style':{'background': 'green', 'color': 'white', 'border': '1px solid gray',}},
      {'val':3,'title':'DECLINE','class':'status-text label btn-sm col-xs-4 margin-btm','style':{'background': 'red', 'color': 'white', 'border': '1px solid gray',}},
      {},
      {},
      {},
      {},
      {},
      {'val':9,'title':'Not a Process','class':'status-text label btn-sm col-xs-4 margin-btm','style':{'background': 'gray', 'color': 'dark-gray', 'border': '1px solid gray',}}
    ];

  @ViewChild(ListLayoutComponent) child;

  itemShow: any;
  trans_status: any = 9;
  modelName = '';
  itemService: any;
  fav:any[]= [];
  constructor(private sharedService: SharedService,
              private router: Router,
              private confirmationService: ConfirmationService,
              public translate: TranslateService,
              private sanitizer: DomSanitizer,
              private sharedservice: SharedService,
              private modalService: NgbModal,
              private messageService: MessageService)
  {

  if(localStorage.getItem('showMenu')) {
    const showMenu = JSON.parse(localStorage.getItem('showMenu'));
    this.showMenu = showMenu;
  }


  this.routeLinks = [
    {
      label: 'Main',
      link: './',
      index: 0
    }, {
      label: 'List',
      link: './list',
      index: 1
    }
  ];


  const userdata = JSON.parse(localStorage.getItem('currentUser'));
  if (userdata) {
    this.userRoles = userdata.roles.description;

  }

    Observable.interval(2000).take(10).subscribe(x => { // will execute every 30 seconds
        this.setTransStatus();
    });


  }
  toggleIcon() {
    const currentScr = JSON.parse(localStorage.getItem('current_screen'));

    let name = '';
    let code = '';
    if(currentScr) {
      name = currentScr.link;
      code = currentScr.code;
    }

    let favor: Favorites = new Favorites();
    if(this.icon=="star-o"){
      this.icon="star";
      this.color="#FFBA35";
      favor.scr_name = name;
      favor.scr_code = code;
      favor.favor = 1;
      this.sharedService.setScreen(favor).subscribe();
    } else {
        this.icon = "star-o";
        this.color="#415A63";
      favor.scr_name = name;
      favor.scr_code = code;
        favor.favor = 0;
        this.sharedService.setScreen(favor).subscribe();
    }
  }

  pinsearch() {
    let pinsearch = localStorage.getItem('filter_'+this.modelName);
    let pinsearchsum = localStorage.getItem('filtersumm_'+this.modelName);

    if(pinsearch) {
      localStorage.removeItem('filter_'+this.modelName);
      if(pinsearchsum){
        localStorage.removeItem('filtersumm_'+this.modelName);
      }
      this.child.getAll();
    } else {
      let currentfilter = localStorage.getItem('filter');
      let currentfiltersum = localStorage.getItem('summ');

      if(currentfilter) {
        localStorage.setItem('filter_'+this.modelName,currentfilter);
      }
      if(currentfiltersum) {
        localStorage.setItem('filtersumm_'+this.modelName,currentfiltersum);
      }
    }

  }

  ispined(){
    let pinsearch = localStorage.getItem('filter_'+this.modelName);
    if(pinsearch) {
      return 'red';
    }
    return '';
  }

  toggleMenu() {
    if(this.showMenu){

      this.showMenu = false;
    } else {

      this.showMenu = true;
    }
  }

  updateHome() {
    this.confirmationService.confirm({
      header: this.translate.instant('Update Home Page'),
      message: this.translate.instant('Are you sure about update home page ?'),
      icon: 'fa fa-question-circle',
      accept: () => {
        let urltxt =  "";
        const userdata = JSON.parse(localStorage.getItem('currentUser'));
        if(this.router.url === userdata.home_form) {
          urltxt =  "/dashboard";
          this.hcolor = "";
        } else {
          urltxt =  this.router.url;
          this.hcolor = "#FFBA35";
        }
        this.sharedService.saveHomePage(urltxt).subscribe(
          homepage => {
            userdata.home_form = urltxt;
            localStorage.setItem('currentUser',JSON.stringify(userdata));
          }, error => {
            console.log(error);
          });
      }
    });
  }
  setTransStatus(){
    this.trans_status = this.sharedService.getTransStatus();
    //console.log('this.trans_status --> ', this.trans_status);
  }

  updateShow() {
    this.itemService = this.sharedService.getItemService();
    this.itemShow = this.sharedService.getItemShow();
    this.modelName = this.sharedService.getModelName();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.routeButtons = this.sharedService.getButtons();
    this.routeBtmButtons = this.sharedService.getBtmButtons();
    this.setTransStatus();
  }

  ngOnInit (): void {
    if(localStorage.getItem('showMenu')) {
      const showMenu = JSON.parse(localStorage.getItem('showMenu'));
      this.showMenu = showMenu;
    }
    this.setTransStatus();
    this.marginzero = this.sanitizer.bypassSecurityTrustStyle("margin-right:0px;margin-left:0px;");
      const currentScr = JSON.parse(localStorage.getItem('current_screen'));
    let name = '';
    let code = '';
      if(currentScr){
        name = currentScr.link;
        code = currentScr.code;
      }

    this.router.events.subscribe((res) => {

      this.activeLinkIndex = this.routeLinks.indexOf(this.routeLinks.find(tab => tab.link === '.' + this.router.url));
      this.title = this.sharedService.getTitle();
      this.routeButtons = this.sharedService.getButtons();
      this.routeBtmButtons = this.sharedService.getBtmButtons();
      this.itemService = this.sharedService.getItemService();
      this.itemShow = this.sharedService.getItemShow();

      const userdata = JSON.parse(localStorage.getItem('currentUser'));
      if (userdata) {
        this.userRoles = userdata.roles.description;
        if(this.router.url === userdata.home_form) {
          this.hcolor = "#FFBA35";
        } else {
          this.hcolor = "";
        }
        let value:any;
        let active:any;
        if(this.fav.length === 0 && this.askfav === true){
          this.askfav = false;
          const favs = JSON.parse(localStorage.getItem('favs'));
          if(favs) {
            this.fav = favs;

            for(let i=0;i<favs.length;i++) {
              value = favs[i].label;
              active=favs[i].value;

              if (name === value ) {
                this.icon="star";
                this.color="#FFBA35";
              }

            }
          } else {
            this.sharedService.getAllFavor().subscribe(
              fav=>{
                this.fav = fav;
                localStorage.setItem('favs',JSON.stringify(fav));
                for(let i=0;i<fav.length;i++) {
                  value = fav[i].label;
                  active=fav[i].value;

                  if (name === value ) {
                    this.icon="star";
                    this.color="#FFBA35";
                  }

                }

              }
            );
          }

        } else {
          for(let i=0;i<this.fav.length;i++) {
            value = this.fav[i].label;
            active= this.fav[i].value;
            if (name === value ) {
              this.icon="star";
              this.color="#FFBA35";
            }

          }
        }

      }

    });

    this.title = this.sharedService.getTitle();
    this.routeButtons = this.sharedService.getButtons();
    this.routeBtmButtons = this.sharedService.getBtmButtons();
    this.itemService = this.sharedService.getItemService();
    this.itemShow = this.sharedService.getItemShow();
    this.modelName = this.sharedService.getModelName();
    if( this.modelName === 'taskpost'){
      this.routeLinks = [
        {
          label: 'List',
          link: './list',
          index: 1
        }
      ];
    }
    const userdata = JSON.parse(localStorage.getItem('currentUser'));
    if (userdata) {
      this.userRoles = userdata.roles.description;
      if(this.router.url === userdata.home_form) {
        this.hcolor = "#FFBA35";
      } else {
        this.hcolor = "";
      }
    }
    let value:any;
    let active:any;
    const favs = JSON.parse(localStorage.getItem('favs'));
    if(favs) {
      this.fav = favs;

      for(let i=0;i<favs.length;i++) {
        value = favs[i].label;
        active=favs[i].value;

        if (name === value ) {
          this.icon="star";
          this.color="#FFBA35";
        }

      }
    } else {
      this.sharedService.getAllFavor().subscribe(
        fav => {
          this.fav = fav;
          localStorage.setItem('favs',JSON.stringify(fav));

          for (let i = 0; i < fav.length; i++) {
            value = fav[i].label;
            active = fav[i].value;
            if (name === value) {
              this.icon = "star";
              this.color = "#FFBA35";
            }

          }
        }
      );
    }
  }

  getScreenName():string {
    let urltxt =  this.router.url.replace(/^\//, '');
    let urlparts = urltxt.split('/');
    return urlparts[0];
  }

  isList():boolean{
    let urltxt =  this.router.url.replace(/^\//, '');
    let urlparts = urltxt.split('/');
    return (urlparts[1] === 'list');
  }

  permissionAllow(button:string):boolean {
    const screen = this.getScreenName();
    let role:string = '';
    if (button === 'undoButton' || button === 'saveButton' || button === 'saveBtmButton' ||button === 'undoBtmButton' ) return true;
    switch(button) {
      case 'newButton': {
        role = 'create';
        break;
      }
      case 'recordButton': {
        role = 'rowinfo';
        break;
      }
      case 'editButton': {
        role = 'update';
        break;
      }
      case 'deleteButton': {
        role = 'delete';
        break;
      }
      case 'searchButton': {
        role = 'search';
        break;
      }
      case 'searchBtmButton': {
        role = 'search';
        break;
      }
      case 'excelButton': {
        role = 'excel';
        break;
      }
      case 'printButton': {
        role = 'print';
        break;
      }
      case 'emailButton': {
        role = 'print';
        break;
      }
      case 'historyButton': {
        role = 'history';
        break;
      }
      case 'restoreButton': {
        role = 'restore';
        break;
      }
      case 'attachmentsButton': {
        role = 'attachments';
        break;
      } case 'recordData': {
        role = 'record';
        break;
      } case 'undoEditing': {
        role = 'undo';
        break;
      } case 'itemsRecovery': {
        role = 'recovery';
        break;
      }

      default: {
        role = '';
        break;
      }
    }
    let Osystem = 'setting';
    if(localStorage.getItem('OpenSystem')) {
      Osystem = localStorage.getItem('OpenSystem');
    }
    if(this.userRoles.indexOf(Osystem+'.'+screen+'.'+role) >= 0 || this.userRoles.indexOf('setting.'+screen+'.'+role) >= 0) {
      return true;
    }
    return false;
  }

  displaypdf(){
    let filename= this.sharedservice.getModelName();
    this.sharedService.getfileshow("76").subscribe(
      filedis => {
        this.filedis = filedis;
        modalRef.componentInstance.filedis = filedis;


      },
      err => {
        console.log(err);
      }
    );
    const modalRef = this.modalService.open(AppPdfComponent);
    modalRef.componentInstance.refShow = this.refShow;
    modalRef.componentInstance.filedis = this.filedis;
    modalRef.componentInstance.screenName = this.modelName;
  }

}



// WEBPACK FOOTER //
// ./src/app/containers/tab-layout/tab-layout.component.ts